import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from './AuthGate';

export default function RequirePermission({ resource, action = 'read', children }) {
  const { can } = useAuth();
  const hasAccess = can(resource, action);

  if (!hasAccess) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 130px)' }}>
        <Paper sx={{ p: 4, maxWidth: 500, textAlign: 'center' }}>
          <LockOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h5" gutterBottom>Access Restricted</Typography>
          <Typography color="text.secondary">
            You don't have permission to view this page. Contact your administrator to request access.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return children;
}
